// The Storefront `CountryCode` enum, not the Admin country list in
// `@intelligems/ig-types`: for example, it has `ZZ` (unknown region) and has
// no `PR`.
import { STOREFRONT_COUNTRY_CODES } from "./storefront-codes.generated";

export type StorefrontCountryCode = (typeof STOREFRONT_COUNTRY_CODES)[number];

const storefrontCountryCodes: ReadonlySet<string> = new Set(
  STOREFRONT_COUNTRY_CODES
);

function isStorefrontCountryCode(
  value: string
): value is StorefrontCountryCode {
  return storefrontCountryCodes.has(value);
}

export type StorefrontCountryCodeResult =
  | { ok: true; country: StorefrontCountryCode }
  | { ok: false; error: "unknownCountry"; country: string };

/**
 * Checks that the country Shopify reports for a storefront page
 * (`window.Shopify.country`) is a Storefront API `CountryCode`. The Storefront
 * API rejects any other value in `@inContext`, so an unknown country is an
 * error result, never a query without a country.
 */
export function toStorefrontCountryCode(
  country: string
): StorefrontCountryCodeResult {
  return isStorefrontCountryCode(country)
    ? { ok: true, country }
    : { ok: false, error: "unknownCountry", country };
}
